import { jsx as r } from "react/jsx-runtime";
const t = "forma-ui__progress-bar__root", e = "forma-ui__progress-bar__bar", o = {
  root: t,
  bar: e
}, c = ({ value: s, max: a }) => /* @__PURE__ */ r("div", { className: o.root, children: /* @__PURE__ */ r("div", { className: o.bar, style: { width: s * 100 / a + "%" } }) });
export {
  c as default
};
